import { useTheme } from '../../contexts/ThemeContext';
import { themeOption, nextTheme } from '../ThemeToggle';

/* Home page skin of the app-wide theme toggle: same options, cycle and storage. */
export default function ThemeSwitch({ variant = 'icon' }) {
  const { theme, setTheme } = useTheme();
  const current = themeOption(theme);
  const next = themeOption(nextTheme(current.value));
  const { icon: Icon, label } = current;
  const aria = `Theme: ${label}. Switch to ${next.label.toLowerCase()}.`;

  if (variant === 'row') {
    return (
      <button type="button" onClick={() => setTheme(next.value)} aria-label={aria} data-testid="theme-switch-menu">
        <span className="inline-flex items-center gap-3"><Icon size={18} aria-hidden="true" /> Theme: {label}</span>
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={() => setTheme(next.value)}
      className="a9l-menu-btn a9l-nav__theme"
      aria-label={aria}
      title={`Theme: ${label}`}
      data-testid="theme-switch"
      data-theme-current={current.value}
    >
      <Icon size={17} aria-hidden="true" />
    </button>
  );
}
